<template>
  <q-table
    flat
    bordered
    :data="reports"
    row-key="id"
    :columns="captureColumns"
    :pagination="pagination"
    no-data-label="Não foram encontrados resultados, de acordo com os filtros informados."
  >
    <template v-slot:body-cell-campaign_name="props">
      <q-td :props="props">
        <router-link
          v-if="props.row.campaign_id"
          class="text-primary"
          :to="{ name: 'EditCampaign', params: { id: props.row.campaign_id, tabCurrent: 'detalhamento' } }"
        >
          {{ formatCaptureNamedId(props.row.campaign_name, props.row.campaign_id) }}
        </router-link>
        <span v-else>{{ formatCaptureNamedId(props.row.campaign_name, props.row.campaign_id) }}</span>
      </q-td>
    </template>

    <template v-slot:body-cell-click_campaign_name="props">
      <q-td :props="props">
        <router-link
          v-if="props.row.click_campaign_id"
          class="text-primary"
          :to="{ name: 'EditCampaign', params: { id: props.row.click_campaign_id, tabCurrent: 'detalhamento' } }"
        >
          {{ formatCaptureNamedId(props.row.click_campaign_name, props.row.click_campaign_id) }}
        </router-link>
        <span v-else>{{ formatCaptureNamedId(props.row.click_campaign_name, props.row.click_campaign_id) }}</span>
        <q-badge v-if="props.row.campaign_mismatch" color="orange" class="q-ml-sm" :label="$t('campaign_mismatch_badge')" />
      </q-td>
    </template>

    <template v-slot:body-cell-site_name="props">
      <q-td :props="props">
        <a
          v-if="props.row.site_id"
          class="text-primary cursor-pointer"
          @click.prevent="goToChannel(props.row.site_id)"
        >
          {{ formatCaptureNamedId(props.row.site_name, props.row.site_id) }}
        </a>
        <span v-else>{{ formatCaptureNamedId(props.row.site_name, props.row.site_id) }}</span>
      </q-td>
    </template>

    <template v-slot:body-cell-campaign_mismatch="props">
      <q-td :props="props">
        <q-badge
          v-if="props.row.campaign_mismatch"
          color="orange"
          :label="$t('yes')"
        />
        <span v-else>{{ $t('no') }}</span>
      </q-td>
    </template>

    <template v-slot:body-cell-status="props">
      <q-td :props="props">
        <q-badge
          :color="captureStatusColor(props.row.status, props.row)"
          class="q-pa-xs"
          style="max-width: 280px; white-space: normal; height: auto"
          :label="props.value"
        />
        <q-tooltip
          content-class="bg-secondary text-white"
          content-style="font-size: 12px; max-width: 360px"
          anchor="top middle"
          self="bottom middle"
        >
          {{ props.value }}
        </q-tooltip>
      </q-td>
    </template>

    <template v-slot:body-cell-clickId="props">
      <q-td :props="props">
        <div class="ellipsis" style="max-width: 220px">
          {{ props.row.clickId }}
        </div>
        <q-tooltip
          v-if="props.row.clickId?.length > 24"
          content-class="bg-secondary text-white"
          content-style="font-size: 12px"
          anchor="top middle"
          self="bottom middle"
        >
          {{ props.row.clickId }}
        </q-tooltip>
      </q-td>
    </template>

    <template v-slot:body-cell-price="props">
      <q-td :props="props">
        {{ !isNaN(props.row.price) ? parseMoney(props.row.price) : props.row.price }}
      </q-td>
    </template>

    <template v-slot:bottom>
      <q-toolbar class="bg-transparent" :class="!$q.dark.isActive ? 'text-dark' : 'text-white'">
        Total:{{ reqPagination.total }}
        <q-space />
        <q-pagination
          unelevated
          v-model="currentPage"
          color="primary"
          :max="reqPagination.last_page || 1"
          :max-pages="6"
          boundary-numbers
          direction-links
        />
      </q-toolbar>
    </template>
  </q-table>
</template>

<script>
import ReportMixin from '../../mixins/ReportMixin';

export default {
  name: 'ListCaptureReports',
  mixins: [ReportMixin],

  data() {
    return {
      pagination: {
        sortBy: 'dateCreated',
        descending: true,
        rowsPerPage: 10
      }
    };
  },

  watch: {
    currentPage() {
      if (this.reqPagination.from != this.reqPagination.current_page) {
        this.getCaptureReport(`%26page=${this.currentPage}`, `%26per_page=${this.pagination.rowsPerPage}`);
      }
    }
  },

  computed: {
    currentPage: {
      get() {
        return this.reqPagination.current_page;
      },
      set(value) {
        this.ActionSetPagination({
          ...this.reqPagination,
          current_page: value
        });
      }
    }
  },

  created() {
    this.ActionSetFilterReports();
    this.ActionSetReports();
    this.getCaptureReport(null, '%26per_page=' + this.pagination.rowsPerPage);
  },

  methods: {
    goToChannel(siteId) {
      this.$router.push({ path: '/channel', query: { site_id: siteId } });
    }
  }
};
</script>
